module.exports = __webpack_public_path__ + "11f68b85b54bc53a7344b1a9bc814435.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/FuturaLT.ttf
// module id = 302
// module chunks = 0